document.addEventListener("DOMContentLoaded", function () {

            const cards = document.querySelectorAll('.hairdonor-saloon');
            const input = document.querySelector('.js-zip');
            let val = null;

            if (cards !== null) {
                countCards('.hairdonor-saloon', '.js-total');
            }

            if (input !== null) {
                input.addEventListener('search', (e) => {
                    e.preventDefault();
                    resetCards('.hairdonor-saloon');
                });

                input.addEventListener('keyup', (e) => {
                    e.preventDefault();
                    if (input.value.length == 0) {
                        resetCards('.hairdonor-saloon');
                        return;
                    }
    
                    countCards('.is-in-range', '.js-total');
                    cards.forEach((card) => {
                        card.classList.add('d-none');
                        console.log(input.value.toLowerCase())
                        if (matches(card.dataset.city.toLowerCase(), input.value.toLowerCase()) || matches(card.dataset.zip, parseInt(input.value))) {
                            card.classList.add('is-in-range', 'd-block');
                            card.classList.remove('d-none');
                        } else {
                            card.classList.remove('is-in-range', 'd-block');
                        }
                    });
    
                });
                
            }

            
        });

            function resetCards(targets) {
                let allCards = document.querySelectorAll(targets);
                allCards.forEach((card) => card.classList.remove('d-none'));
                if (allCards !== mull) {
                    countCards(targets, '.js-total');
                }
            }

            function matches(text, partial) {
                if (text !== isNaN) {
                    return text.indexOf(partial) > -1;
                }
                return text.toLowerCase().indexOf(partial.toLowerCase()) > -1;
            }

            function countCards(targets, target) {
                let t = document.querySelector(target);
                if (t !== null) {
                    t.innerHTML = document.querySelectorAll(targets).length;
                }
            }